import { apiRequest } from './apiClient';

export const masterEndpoints = {
  positions: '/positions',
  departments: '/departments',
  functions: '/functions',
  experienceRanges: '/experience-ranges',
  cities: '/cities',
};

export async function fetchMasters() {
  const entries = await Promise.all(Object.entries(masterEndpoints).map(async ([key, path]) => {
    const result = await apiRequest(path);
    return [key, result.data];
  }));
  return Object.fromEntries(entries);
}

export async function createMasterEntry(category, name, isActive, extra = {}) {
  const result = await apiRequest(masterEndpoints[category], { method: 'POST', body: JSON.stringify({ name, isActive, ...extra }) });
  return result.data;
}

export async function updateMasterEntry(category, id, name, isActive, extra = {}) {
  const result = await apiRequest(`${masterEndpoints[category]}/${id}`, { method: 'PATCH', body: JSON.stringify({ name, isActive, ...extra }) });
  return result.data;
}

export async function deleteMasterEntry(category, id) {
  await apiRequest(`${masterEndpoints[category]}/${id}`, { method: 'DELETE' });
}
